package de.oevbs.kunde.kundenportal2.components

import de.oevbs.kunde.kundenportal2.services.contract.withBlankDash
import dev.fritz2.core.Id
import dev.fritz2.core.RenderContext
import dev.fritz2.core.joinClasses


/**
 * Detail Grid Container
 *
 * @param id die ID des Container
 * @param entries beliebige Einträge im Grid
 */
fun RenderContext.detailsGrid(
    id: String = Id.next(),
    entries: RenderContext.() -> Unit
) = div("grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-4 gap-1 text-left mt-3", id) {
    entries()
}

/**
 * Einzelnes GRID Item bestehend aus [title] [value] und der option [longColumn]
 * um den Content über eine Zeile darzustellen.
 *
 * @param title der Titel eines Wertes
 * @param value der Wert selber
 * @param longColumn boolesches Flag, das angibt, ob sich ein Grid-Eintrag über alle Spalten des Grids erstrecken soll
 */
fun RenderContext.detailsGridEntry(
    title: RenderContext.() -> Unit,
    value: RenderContext.() -> Unit,
    longColumn: Boolean = false
) {
    div("m-0 mr-2 w-max overflow-hidden") {
        title()
    }
    div(joinClasses("m-0 w-fit vui-label-4 text-ellipsis", "xl:col-start-2 xl:col-span-3".takeIf { longColumn })) {
        value()
    }
}

/**
 * Einzelnes GRID Item bestehend aus [title] [value] und der option [longColumn]
 * um den Content über eine Zeile darzustellen.
 *
 * @param title der Titel eines Wertes
 * @param value der Wert selber
 * @param longColumn boolesches Flag, das angibt, ob sich ein Grid-Eintrag über alle Spalten des Grids erstrecken soll
 */
fun RenderContext.detailsGridEntry(
    title: String,
    value: RenderContext.() -> Unit,
    longColumn: Boolean = false
) {
    detailsGridEntry(
        title = {
            b { +"$title:" }
        },
        value,
        longColumn
    )
}

/**
 * Einzelnes GRID Item bestehend aus [title] [value] und der option [longColumn]
 * um den Content über eine Zeile darzustellen.
 *
 * @param title der Titel eines Wertes
 * @param value der Wert selber
 * @param longColumn boolesches Flag, das angibt, ob sich ein Grid-Eintrag über alle Spalten des Grids erstrecken soll
 */
fun RenderContext.detailsGridEntry(
    title: String,
    value: String?,
    longColumn: Boolean = false
) {
    detailsGridEntry(
        title = {
            b { +"$title:" }
        },
        value = {
            span { +(value?.let { it.withBlankDash() } ?: "―") }
        },
        longColumn
    )
}

/**
 * Liste `<ul>` für das DetailGrid
 *
 * @param entries beliebige (Listen-)Einträge
 */
fun RenderContext.detailsGridEntryValueList(entries: RenderContext.() -> Unit) {
    ul("list-none") {
        entries()
    }
}